import Inc2734_WP_Share_Buttons_Button from './_button.js';

export default class Inc2734_WP_Share_Buttons_Pinterest extends Inc2734_WP_Share_Buttons_Button {
}
